import { ICostCenter, ITranslatableEntity, IVatRate } from './common';
import type { IPreliminaryInvoice } from './invoice';
import { IMatter } from './matter';
import { IMatterPhase } from './matterPhase';
import type { IPrincipalCompany } from './principalCompany';
import type { IPrincipalPrivatePerson } from './principalPrivatePerson';
import { ITranslations } from './transactionTypes';
import { IUnit } from './unit';
import { IUser } from './user';

export interface IExpense {
  id: string;
  createdOn: string;
  subject: string;
  description?: string;
  units?: number;
  unitPriceNet?: number;
  salesPriceNet?: number;
  totalPriceNet?: number;
  totalPriceGross?: number;
  taxFree: boolean;
  status: ExpenseStatus;
  currency: string;
  expenseDate: string;
  reviewedDate?: Date;
  costForward: CostForward;

  matterId: string;
  expenseTypeId: string;
  expenseUserId?: string;
  vatRateId?: string;
  principalCompanyId?: string;
  principalPrivatePersonId?: string;
  unitId?: string;
  ledgerAccountId?: string;
  salesAccountId?: string;
  costCenterId?: string;
  reviewerId?: string;
  preliminaryInvoiceId?: string;
  matterPhaseId?: string;

  matter?: IMatter;
  expenseType?: IExpenseType;
  expenseUser?: IUser;
  principalCompany?: IPrincipalCompany;
  principalPrivatePerson?: IPrincipalPrivatePerson;
  costCenter?: ICostCenter;
  vatRat?: IVatRate;
  unit: IUnit;
  ledgerAccount?: ISalesAccount;
  salesAccount?: ISalesAccount;
  reviewer?: IUser;
  preliminaryInvoice?: IPreliminaryInvoice;
  matterPhase?: IMatterPhase;
  hasImportantNotes: boolean;
  hasNotes: boolean;
}
export enum ExpenseStatus {
  APPROVED = 'approved',
  INVOICED = 'invoiced',
  NON_BILLABLE = 'non-billable',
  OPEN = 'open',
  PRELIM_INVOICE = 'preliminary-invoice',
  REVIEWED = 'reviewed',
}
export enum ExpenseFilters {
  MY = 'my_own',
  OTHER = 'other_authors',
  ALL_EXPENSES = 'all_transactions',
  OPEN_EXPENSES = 'open_transactions',
}
export enum CostForward {
  NO_COST_FORWARD = 'no-cost-forward',
  BY_PAYER_TAXABILITY = 'by-payer-taxability',
  BY_PURCHASE_TAXABILITY = 'by-purchase-taxability',
}
export interface IExpenseType {
  id: string;
  status: string;
  name: string;
  description?: string;
  translations: ITranslations[];
  unitPrice?: number;
  units?: number;
  salesPrice?: number;
  costPrice?: number;
  taxFree: boolean;
  costForward: boolean;
  vatRateId?: string;
  unitId?: string;
  ledgerAccountId?: string;
  salesAccountId?: string;
  categoryId?: string;
  vatRat?: IVatRate;
  unit?: IUnit;
  ledgerAccount?: ISalesAccount;
  salesAccount?: ISalesAccount;
  category?: ITranslatableEntity;
}

export interface ISalesAccount {
  type?: string;
  name?: string;
  description?: string;
  taxFree: boolean;
}
